import { render, staticRenderFns } from "./Certificacion.vue?vue&type=template&id=5ed43558&"
import script from "./Certificacion.vue?vue&type=script&lang=js&"
export * from "./Certificacion.vue?vue&type=script&lang=js&"
import style0 from "./Certificacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports